import { FormEvent, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLogin } from '@hooks/useAuth';

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const loginMutation = useLogin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const response = await loginMutation.mutateAsync({ email, password });
    const from = typeof location.state?.from === 'string' ? location.state.from : '/';
    navigate(from || '/', { replace: true, state: response });
  }

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="auth-copy">
          <p className="hero-kicker">Founder CRM</p>
          <h1>Sign in to the CRM workspace</h1>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <label className="form-field">
            <span>Email</span>
            <input
              type="email"
              autoComplete="username"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="founder@ezflow.ai"
              required
            />
          </label>

          <label className="form-field">
            <span>Password</span>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Enter your password"
              required
            />
          </label>

          {loginMutation.error ? (
            <p className="form-error">{loginMutation.error instanceof Error ? loginMutation.error.message : 'Unable to sign in.'}</p>
          ) : null}

          <button type="submit" className="button button-primary" disabled={loginMutation.isPending}>
            {loginMutation.isPending ? 'Signing In…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
